import React, { useEffect, useRef, useState } from 'react'
import { useLoading } from '../../../context/LoadingContext';
import { useTranslation } from 'react-i18next';
import { CustomAdvancedMenuList, CustomDialog } from '../../../components/StyledComponents';
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ControlpanelPrimaryButton, ControlpanelSecondaryButton, GrayIconButton } from '../../../components/StyledButton';
import CloseIcon from '@mui/icons-material/Close';
import CustomInput from '../../../components/CustomInput';
import { useConnectWS, useGetDeviceDetails, useReadCard } from '../../../hooks/useCheckid';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import CustomSelect from '../../../components/CustomSelect';
import { useGetGeneralPolicyCountry } from '../../../hooks/useGeneralService';
import { initialSelectedPhoneCountry } from '../../../assets/data/common';
import DoneIcon from "@mui/icons-material/Done";
import ErrorIcon from "@mui/icons-material/ErrorOutline";
import CustomDatePicker from '../../../components/CustomDatePicker';
import { useAuth } from '../../../context/AuthContext';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { format } from 'date-fns';
import AddIcon from '@mui/icons-material/Add';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import {
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    Paper,
    Popper,
} from "@mui/material";
import ImportIcon20pxSvg from '../../../assets/images/icons/ImportIcon20pxSvg';
import Webcam from "react-webcam";
import avatar_2 from "../../../assets/images/logo/avatar-default-logo.png";
import * as faceapi from 'face-api.js';
import ImportIcon16pxSvg from '../../../assets/images/icons/ImportIcon16pxSvg';

const AddRegistrationsDialog = ({ dataInfo, onClose, refreshData, handleRefreshData, refresh }) => {
    const [show, hide] = useLoading();
    const { t } = useTranslation();
    const [readingCard, setReadingCard] = useState(false);
    const [isMissingSoftware, setIsMissingSoftware] = useState(false);
    const getDevice = useGetDeviceDetails();
    const connectWS = useConnectWS();
    const readCard = useReadCard();
    const language = useSelector((state) => state.languageR.language);
    const [isReadCard, setIsReadCard] = useState(false);
    const [dataReadcard, setDataReadcard] = useState(null);
    const skipBlurRef = useRef(false);
    const [onBlurEvent, setonBlurEvent] = useState(false);
    const { data: countries } = useGetGeneralPolicyCountry();
    const [selectedPhoneCountry, setSelectedPhoneCountry] = useState(
        initialSelectedPhoneCountry
    );
    const { genaralSettingDateFormat } = useAuth();
    const [openAdvanced, setOpenAdvanced] = useState(false);

    const [openCamera, setOpenCamera] = useState(false);
    const webcamRef = useRef(null);
    const [faceValid, setFaceValid] = useState(false);
    const [faceMessage, setFaceMessage] = useState('');

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();

        setFormData((prev) => ({
            ...prev,
            faceImage: imageSrc,
        }));

        setOpenCamera(false);
    };

    const anchorRefAdvanced = useRef(null);
    const handleQuickFilterChange = () => {
    };
    const handleToggleAdvanced = () => {
        setOpenAdvanced((prev) => !prev);
    };
    const handleCloseAdvanced = (event) => {
        if (
            anchorRefAdvanced.current &&
            anchorRefAdvanced.current.contains(event.target)
        ) {
            return; // click vào button thì không close
        }
        setOpenAdvanced(false);
    };

    useEffect(() => {
        const loadModels = async () => {
            const MODEL_URL = '/models';

            await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
            await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);
        };

        loadModels();
    }, []);

    useEffect(() => {
        let interval;

        if (openCamera) {
            interval = setInterval(async () => {
                if (!webcamRef.current?.video) return;

                const video = webcamRef.current.video;

                const detections = await faceapi
                    .detectAllFaces(
                        video,
                        new faceapi.TinyFaceDetectorOptions()
                    )
                    .withFaceLandmarks();

                // Không có mặt
                if (detections.length === 0) {
                    setFaceValid(false);
                    setFaceMessage('Không tìm thấy khuôn mặt');
                    return;
                }

                // Nhiều mặt
                if (detections.length > 1) {
                    setFaceValid(false);
                    setFaceMessage('Chỉ được có 1 khuôn mặt');
                    return;
                }

                const face = detections[0];
                const box = face.detection.box;

                const videoWidth = video.videoWidth;
                const videoHeight = video.videoHeight;

                // Tỉ lệ mặt
                const faceArea = box.width * box.height;
                const totalArea = videoWidth * videoHeight;

                const ratio = faceArea / totalArea;

                // mặt quá nhỏ
                if (ratio < 0.08) {
                    setFaceValid(false);
                    setFaceMessage('Đưa mặt lại gần hơn');
                    return;
                }

                // kiểm tra portrait
                const isPortrait = box.height > box.width;

                if (!isPortrait) {
                    setFaceValid(false);
                    setFaceMessage('Vui lòng chụp chính diện');
                    return;
                }

                // nằm giữa frame
                const centerX = box.x + box.width / 2;
                const centerY = box.y + box.height / 2;

                const validX =
                    centerX > videoWidth * 0.3 &&
                    centerX < videoWidth * 0.7;

                const validY =
                    centerY > videoHeight * 0.2 &&
                    centerY < videoHeight * 0.8;

                if (!validX || !validY) {
                    setFaceValid(false);
                    setFaceMessage('Đưa mặt vào giữa khung');
                    return;
                }

                setFaceValid(true);
                setFaceMessage('Khuôn mặt hợp lệ');
            }, 500);
        }

        return () => clearInterval(interval);
    }, [openCamera]);

    const initialFormData = {
        fullName: '',
        personalID: '',
        email: '',
        phone: '',
        joinDate: '',
        faceImage: '',
        langId: localStorage.getItem("i18nextLngId")
    };

    const [formData, setFormData] = useState(initialFormData);

    const [validationMessages, setValidationMessages] = useState({
        fullName: "",
        personalID: "",
        email: "",
        phone: "",
        joinDate: "",
    });

    const handleDataChange = (name, newData) => {
        setFormData((prevData) => ({
            ...prevData,
            [name]: newData,
        }));
    };

    const handleReadCard = (cardId) => {
        try {
            show();
            setReadingCard(true);
            let deviceName = false;

            connectWS.mutate(
                {},
                {
                    onSuccess: (data) => {
                        setIsMissingSoftware(false);
                        hide(); // ẩn loading của connectWS
                        show(); // bật lại loading cho getDevice + readCard

                        getDevice.mutate(
                            { lang: language },
                            {
                                onSuccess: (dataReadcard) => {
                                    if (dataReadcard.deviceSN === "54822502250122") {
                                        deviceName = true;
                                    }
                                },
                                onError: (error) => {
                                    hide(); // **luôn dừng loading**
                                    setReadingCard(false); // dừng trạng thái reading
                                    toast.error(error.message || error);
                                },
                            }
                        );

                        readCard.mutate(
                            {
                                lang: language,
                                code: cardId.slice(-6),
                                deviceName: deviceName,
                            },
                            {
                                onSuccess: (dataReadcard) => {
                                    hide();
                                    setReadingCard(false);
                                    handleReadCardSuccess(dataReadcard);

                                    if (
                                        dataReadcard.optionalDetails.personalNumber !==
                                        formData.personalID
                                    ) {
                                        return setValidationMessages((prev) => ({
                                            ...prev,
                                            personalID: "common.content-014",
                                        }));
                                    }

                                    // if (dataReadcard.optionalDetails) {
                                    //     const { fullName } = dataReadcard.optionalDetails;

                                    //     // 👉 chỉ set fullName + image vào form
                                    //     setFormData((prev) => ({
                                    //         ...prev,
                                    //         fullName: fullName || "",
                                    //         faceImage: formatBase64Image(dataReadcard.image) || ""
                                    //     }));

                                    //     // 👉 vẫn giữ toast nếu bạn cần
                                    //     toast.success(t("common.content-013"));
                                    // }
                                },
                                onError: (error) => {
                                    hide(); // **luôn dừng loading**
                                    setReadingCard(false);
                                    if (error.error === 1102) {
                                        toast.error(t("common.CAN"));
                                    } else {
                                        toast.error(error.message || t("common.content-029"));
                                    }
                                },
                            }
                        );
                    },
                    onError: (error) => {
                        hide(); // **luôn dừng loading**
                        setReadingCard(false);
                        setIsMissingSoftware(true);
                        toast.error(t("common.content-028"));
                    },
                }
            );
        } catch (error) {
            hide(); // **luôn dừng loading**
            setReadingCard(false);
            toast.error(t("common.content-029"));
        }
    };

    const handleReadCardSuccess = (data) => {
        setDataReadcard(data);
        setIsReadCard(true);

        const formattedImage = formatBase64Image(data.image);

        setFormData((prev) => ({
            ...prev,
            faceImage: formattedImage,
            fullName: data.optionalDetails?.fullName || ""
        }));
    };

    const handleCloseDialog = () => {
        setFormData(initialFormData);
        onClose();
    };

    const updateFormDataAndValidate = (name, value) => {
        if (name === 'departmentPrefix') {
            // Giới hạn 2 ký tự + uppercase
            const trimmedValue = value.toUpperCase().slice(0, 2);

            setFormData((prevData) => ({
                ...prevData,
                [name]: trimmedValue,
            }));
        } else {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleBlur = () => {
        if (skipBlurRef.current) {
            skipBlurRef.current = false;
            return;
        }

        const id = formData.personalID.trim();

        if (!/^\d{12}$/.test(id)) {
            setValidationMessages((prev) => ({
                ...prev,
                personalID: "common.content-009", // sai định dạng
            }));
        } else {
            setValidationMessages((prev) => ({
                ...prev,
                personalID: "",
            }));
            setonBlurEvent(true);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        updateFormDataAndValidate(name, value);

        if (name === "phone") {
            const phone = value.trim();

            if (!phone) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            } else if (!/^\d{9,13}$/.test(phone)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "common.content-024", // bạn tự define i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    phone: "",
                }));
            }
        }

        if (name === "email") {
            const email = value.trim();

            if (!email) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "validation.email-invalid-format", // key i18n
                }));
            } else {
                setValidationMessages((prev) => ({
                    ...prev,
                    email: "",
                }));
            }
        }
    };

    const handleSubmit = async () => {
        if (
            !formData.fullName ||
            !formData.personalID ||
            !formData.joinDate ||
            !formData.email ||
            !formData.phone
        ) {
            toast.error(t("common.fill-required"));
            return;
        }

        // 👉 remove prefix base64
        const cleanBase64 = formData.faceImage
            ? formData.faceImage.replace(/^data:image\/\w+;base64,/, "")
            : "";

        const payload = {
            ...formData,
            faceImage: cleanBase64,
            phone: `${selectedPhoneCountry.callingCode}${formData.phone}`,
        };

        toast.success(t("common.add-success"));

        setFormData(initialFormData);
        onClose();
        handleRefreshData?.();
    };

    const generateDateOptions = (start, end) => {
        const result = [];

        const startDate = new Date(start);
        const endDate = new Date(end);

        let current = new Date(startDate);

        while (current <= endDate) {
            result.push({
                label: format(current, genaralSettingDateFormat),
                value: format(current, "yyyy-MM-dd"),
            });

            current.setDate(current.getDate() + 1);
        }

        return result;
    };

    const dateOptions = React.useMemo(() => {
        if (!dataInfo?.startDate || !dataInfo?.endDate) return [];

        return generateDateOptions(dataInfo.startDate, dataInfo.endDate);
    }, [dataInfo]);

    const fileInputRef = useRef(null);

    const handleOpenFile = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData((prev) => ({
                ...prev,
                faceImage: reader.result, // base64
            }));
        };
        reader.readAsDataURL(file);
    };

    const handleOpenCamera = async () => {
        try {
            // check camera permission + device
            const stream = await navigator.mediaDevices.getUserMedia({ video: true });

            // stop ngay để tránh giữ camera
            stream.getTracks().forEach(track => track.stop());

            setOpenCamera(true);
        } catch (error) {
            toast.error(t("common.no-camera") || "Thiết bị không có camera hoặc bị từ chối quyền");
        }
    };

    const formatBase64Image = (base64) => {
        if (!base64) return "";

        if (base64.startsWith("data:image")) return base64;

        // detect loại ảnh (optional nâng cao)
        const isPng = base64.startsWith("iVBOR"); // PNG signature
        const type = isPng ? "image/png" : "image/jpeg";

        return `data:${type};base64,${base64}`;
    };

    return (
        <>
            <CustomDialog maxWidth={'md'} open onClose={handleCloseDialog} keepMounted>
                <DialogTitle>
                    <div className='flex justify-between'>
                        <div className='flex items-center gap-4'>
                            <p className='text-xl font-semibold '>{t('common.add-participant')}</p>
                        </div>
                        <GrayIconButton onClick={handleCloseDialog}>
                            <CloseIcon />
                        </GrayIconButton>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className='space-y-3 mt-4'>
                        <div className="flex items-start justify-between gap-3">
                            <div className="flex items-center justify-center overflow-hidden border border-gray-200 p-[5px] rounded-[4px]">
                                {formData.faceImage ? (
                                    <img
                                        src={formData.faceImage}
                                        alt="preview"
                                        className="w-[168px] h-[170px] object-cover rounded-[4px]"
                                    />
                                ) : (
                                    <img
                                        src={avatar_2}
                                        alt="Default Avatar"
                                        className="w-[168px] h-[170px] object-cover rounded-[4px]"
                                    />
                                )}
                            </div>

                            <div className="flex rounded-md border border-[#DBE8FF] overflow-hidden bg-[#0057FF] h-10">
                                {/* ADD */}
                                <button
                                    onClick={handleOpenFile}
                                    className="flex items-center gap-2 px-4 h-full text-[#FCFCFC] hover:bg-[#00308C]"
                                >
                                    <AddIcon />
                                    {t("common.browser")}
                                </button>

                                <input
                                    type="file"
                                    accept="image/*"
                                    capture="environment"
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    hidden
                                />

                                {/* DIVIDER */}
                                <div className="w-[1px] bg-[#DBE8FF]" />

                                {/* DROPDOWN */}
                                <button
                                    ref={anchorRefAdvanced}
                                    id="advanced-button"
                                    aria-haspopup="true"
                                    onClick={handleToggleAdvanced}
                                    className="px-3 h-full flex items-center justify-center text-[#FCFCFC] hover:bg-[#00308C] transition"
                                >
                                    <ArrowDropDownIcon />
                                </button>
                            </div>
                        </div>

                        <div>
                            <label>{t('common.name')} <span className="text-red-500">*</span></label>
                            <CustomInput name='fullName' value={formData.fullName} handleInputChange={handleInputChange} />
                        </div>

                        <div>
                            <label>{t('common.personal-id')}<span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center">
                                <input
                                    type="number"
                                    name="personalID"
                                    className={`form-control h-[40px] no-spin-buttons relative z-40 pr-12 ${!!validationMessages.personalID ? "invalid" : ""
                                        }`}
                                    value={formData.personalID}
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // ✅ Chỉ cho phép tối đa 12 chữ số
                                        if (value.length <= 12) {
                                            handleInputChange(e);
                                            setFormData((prev) => ({ ...prev }));
                                        }
                                    }}
                                />
                                <ControlpanelPrimaryButton
                                    disabled={
                                        !!validationMessages.personalID || !formData.personalID || readingCard
                                    }
                                    className={`w-[6.25rem] !absolute inset-y-0 right-0 !rounded-none !rounded-r-md !text-nowrap z-50 ${!!validationMessages.personalID ||
                                        !formData.personalID ||
                                        formData.personalID.length !== 12
                                        ? "opacity-50"
                                        : ""
                                        }`}
                                    onMouseDown={() => (skipBlurRef.current = true)}
                                    onClick={() => handleReadCard(formData.personalID)}
                                >
                                    {readingCard ? (
                                        <CircularProgress size={18} color="inherit" />
                                    ) : (
                                        t("button.read-card")
                                    )}
                                </ControlpanelPrimaryButton>
                            </div>
                        </div>

                        <div>
                            <label>{t('common.email')} <span className="text-red-500">*</span></label>
                            <div className="mt-2 relative flex items-center h-10">
                                <input
                                    type="text"
                                    name="email"
                                    className="form-control h-10 pr-10"
                                    value={formData.email}
                                    onChange={handleInputChange}
                                />
                            </div>

                            {/* MESSAGE */}
                            {validationMessages.email && (
                                <p className="mt-2 text-sm text-red-500">
                                    {t(validationMessages.email)}
                                </p>
                            )}
                        </div>

                        <div className="space-y-2 col-span-2">
                            <label className="block">{t("common.phone")} <span className="text-red-500">*</span></label>
                            <div className="relative flex items-center h-10">
                                <div className="flex items-center jus gap-1 ps-3.5 relative z-10">
                                    <img
                                        src={selectedPhoneCountry.nationFlag}
                                        alt="flag-icon"
                                        className="w-6"
                                    />
                                    <span className="text-black">
                                        {selectedPhoneCountry.callingCode}
                                    </span>
                                </div>
                                <input
                                    className={`absolute inset-0 -top-[1px] form-control h-10 ${!!validationMessages.phone ? "invalid" : ""
                                        } ${formData.phone && !validationMessages.phone ? "success" : ""
                                        }`}
                                    value=""
                                    onChange={() => { }}
                                />
                                <input
                                    type="number"
                                    placeholder={selectedPhoneCountry.placeHolder}
                                    name="phone"
                                    className="no-spin-buttons relative z-10 ml-2 flex-1 h-10 outline-none px-2 border-none rounded-r-md bg-transparent item-center"
                                    onChange={handleInputChange}
                                    value={formData.phone}
                                />
                                {formData.phone && !validationMessages.phone && (
                                    <span className="absolute inset-y-[-3px] right-0 px-3 py-3">
                                        <DoneIcon fontSize="small" className="text-green-500" />
                                    </span>
                                )}
                                {!!validationMessages.phone && (
                                    <span className="absolute inset-y-[-3px] right-0 px-3 py-3">
                                        <ErrorIcon fontSize="small" className="text-red-500" />
                                    </span>
                                )}
                            </div>
                            {validationMessages.phone && (
                                <p className="text-sm text-red-500 mt-1">
                                    {t(validationMessages.phone)}
                                </p>
                            )}
                        </div>

                        <div>
                            <label>{t('common.select-date')}</label> <span className='text-[#EF4444] ml-1'>*</span>
                            <CustomSelect
                                name="joinDate"
                                value={formData.joinDate}
                                options={dateOptions}
                                onChange={(e) => handleDataChange("joinDate", e.target.value)}
                                className="!mt-2"
                                dataType="joinDate"
                            />
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className='flex gap-2 px-4 py-4'>
                        <ControlpanelSecondaryButton onClick={handleCloseDialog}>
                            <CloseIcon />
                            <p>{t('button.cancel')}</p>
                        </ControlpanelSecondaryButton>

                        <ControlpanelPrimaryButton
                            onClick={handleSubmit}
                            disabled={
                                !formData.fullName ||
                                !formData.personalID ||
                                !formData.joinDate ||
                                !formData.email ||
                                !formData.phone
                            }
                        >
                            <AddBoxIcon />
                            <p>{t('button.add')}</p>
                        </ControlpanelPrimaryButton>
                    </div>
                </DialogActions>
            </CustomDialog>

            <Popper
                open={openAdvanced}
                anchorEl={anchorRefAdvanced.current}
                placement="bottom-start"
                transition
                disablePortal
                className="z-[9999]"
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin:
                                placement === "bottom" ? "left top" : "left bottom",
                        }}
                    >
                        <Paper style={{ borderRadius: "8px", }}>
                            <ClickAwayListener onClickAway={handleCloseAdvanced}>
                                <CustomAdvancedMenuList
                                    id="advanced-menu"
                                    aria-labelledby="advanced-button"
                                >
                                    <MenuItem onClick={() => {
                                        handleOpenCamera();
                                        setOpenAdvanced(false); // 👈 thêm dòng này
                                    }}>
                                        <Link>
                                            <ImportIcon16pxSvg />
                                            <p>{t("common.take-photo")}</p>
                                        </Link>
                                    </MenuItem>
                                </CustomAdvancedMenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>

            {openCamera && (
                <Dialog open={openCamera} onClose={() => setOpenCamera(false)} maxWidth="sm" fullWidth>
                    <div className="p-4 space-y-3">
                        <div className="relative overflow-hidden rounded-md bg-black">
                            {/* CAMERA */}
                            <Webcam
                                ref={webcamRef}
                                screenshotFormat="image/jpeg"
                                className="w-full h-full object-cover"
                            />

                            {/* FRAME */}
                            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                <div className="relative h-[60%] w-[40%] rounded-xl border-2 border-white shadow-lg overflow-hidden">

                                    {/* Clear area */}
                                    <div className="absolute inset-0 bg-transparent" />

                                    {/* CORNERS */}
                                    <div className="absolute top-0 left-0 w-6 h-6 border-t-4 border-l-4 border-white rounded-tl-md" />
                                    <div className="absolute top-0 right-0 w-6 h-6 border-t-4 border-r-4 border-white rounded-tr-md" />
                                    <div className="absolute bottom-0 left-0 w-6 h-6 border-b-4 border-l-4 border-white rounded-bl-md" />
                                    <div className="absolute bottom-0 right-0 w-6 h-6 border-b-4 border-r-4 border-white rounded-br-md" />

                                    {/* SCAN LINE */}
                                    <div className="scan-line absolute left-0 w-full h-[2px] bg-green-400 opacity-80" />

                                </div>
                            </div>
                        </div>

                        <div className="flex justify-end gap-2">
                            <ControlpanelSecondaryButton onClick={() => setOpenCamera(false)}>
                                {t('button.cancel')}
                            </ControlpanelSecondaryButton>

                            <ControlpanelPrimaryButton
                                onClick={capture}
                                disabled={!faceValid}
                            >
                                {t('common.take-photo')}
                            </ControlpanelPrimaryButton>
                        </div>
                    </div>
                </Dialog>
            )}
        </>
    )
}

export default AddRegistrationsDialog